import { ACTIONS } from "../../common/constants";

const lcoIdDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_LCO_ID_DATA:
      return action.data;
    default:
      return state;
  }
};

export default lcoIdDataReducer;
